import { alpha, Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

const DEEP_LINK_HIGHLIGHT_FADE = '0.4s ease-out';
const RING_WIDTH = '0.125rem';

export enum DeepLinkRingPlacement {
  /** Around the element, with a gap. */
  Outside = 'outside',
  /** Along its inner edge, for an element inside a container that clips its overflow. */
  Inside = 'inside',
}

/*
  The deep-link highlight stays on the card in both states so it fades out when it drops.
  The ring is an outline so its offset gap shows the thread behind the card, which keeps it
  apart from any card colour; the tint is an overlay so it shows over children that paint
  their own background.
*/
export const getDeepLinkHighlightSx =
  (isActive: boolean, ringPlacement: DeepLinkRingPlacement = DeepLinkRingPlacement.Outside) =>
  (theme: Theme): SystemStyleObject<Theme> => ({
    outline: `${RING_WIDTH} solid ${isActive ? theme.palette.custom.OV.sys.secondary : 'transparent'}`,
    outlineOffset:
      ringPlacement === DeepLinkRingPlacement.Outside ? RING_WIDTH : `-${RING_WIDTH}`,
    transition: `outline-color ${DEEP_LINK_HIGHLIGHT_FADE}`,
    '&::after': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: 'inherit',
      backgroundColor: alpha(theme.palette.custom.OV.sys.secondary, 0.12),
      opacity: isActive ? 1 : 0,
      transition: `opacity ${DEEP_LINK_HIGHLIGHT_FADE}`,
      pointerEvents: 'none',
    },
    '@media (prefers-reduced-motion: reduce)': {
      transition: 'none',
      '&::after': { transition: 'none' },
    },
  });
